import React, {ReactNode} from 'react';

import {gt} from 'app/utils/i18n';

interface Props<I extends {id: number | string; name: string | ReactNode}> {
  title: ReactNode;
  items: Array<I>;
  limit?: number;
}

/**
 * Renders and limit a list to be rendered inside a tooltip
 */
export function TooltipList<
  I extends {id: number | string; name: string | ReactNode}
>({title, items, limit = 20}: Props<I>): JSX.Element {
  let append: ReactNode | null = null;

  if (limit < items.length) {
    const overflow = items.length - limit;
    items = items.slice(0, limit);
    append = <div className="mt-2">...{gt('and %s more', overflow)}</div>;
  }

  return (
    <div className="text-left">
      {title != null ? <div className="mb-2">{title}</div> : null}
      <ul className="pl-3 m-0 small">
        {items.map((item) => (
          <li key={item.id}>{item.name}</li>
        ))}
      </ul>
      {append}
    </div>
  );
}
